import Immutable, {fromJS} from 'immutable';
import {push} from 'connected-react-router/immutable';

import config from 'config';
import {createError} from '../services/errors';
import {buildFetch} from '../services/fetch';
import {setThemeId} from '@actions/ui';
import {THEMES} from '@services/utilities';
import {CAMPAIGNSELECTOR, PRIVACY} from '@services/routes';

export const USERCAMPAIGNS_LOADING_ERROR = 'USERCAMPAIGNS_LOADING_ERROR';
export const USERCAMPAIGNS_LOADING_REJECTED = 'USERCAMPAIGNS_LOADING_REJECTED';
export const USERCAMPAIGNS_LOADING_SUCCESS = 'USERCAMPAIGNS_LOADING_SUCCESS';
export const USERCAMPAIGNS_START_LOADING = 'USERCAMPAIGNS_START_LOADING';

export function loadUserCampaignsSuccess(data = {}) {
  return {
    type: USERCAMPAIGNS_LOADING_SUCCESS,
    data,
  };
}

export function startLoadingUserCampaign() {
  return {
    type: USERCAMPAIGNS_START_LOADING,
  };
}

export const loadUserCampaignsError = createError(USERCAMPAIGNS_LOADING_ERROR);

export function loadUserCampaigns() {
  return function (dispatch, getState) {
    const fetch = buildFetch(dispatch);
    dispatch(startLoadingUserCampaign());
    return fetch(`${config.api}/usercampaign`)
      .then(response => {
        const reduxState = getState();
        const isAssessor = reduxState.getIn(['user', 'data', 'role', 'name']) === 'Assessor';

        let {campaign} = response.data;

        if (typeof campaign.data === 'string' || campaign.data instanceof String) {
          campaign.data = JSON.parse(campaign.data);
        }

        const data = Immutable.fromJS(campaign);

        dispatch(setThemeId(isAssessor ? THEMES.BASIC : data.get('theme')));
        dispatch(loadUserCampaignsSuccess(data));

        return data;
      })
      .catch(error => {
        if (error) {
          dispatch(loadUserCampaignsError(error.message));

          const message = error.response?.data?.message;
          if (message.toLowerCase() === 'no selected campaign found.') {
            dispatch(push(CAMPAIGNSELECTOR));
          }

          throw error;
        } else {
          dispatch({type: USERCAMPAIGNS_LOADING_REJECTED});
        }
      });
  };
}

export const SET_CALENDAR_CURRENT_POSITION = 'SET_CALENDAR_CURRENT_POSITION';

export function setCalendarCurrentPosition(position) {
  return function (dispatch, getState) {
    const oldState = getState();
    const campaignId = oldState.getIn(['userCampaign', 'data', 'id']);
    const oldStorage =
      oldState.getIn(['userCampaign', 'data', 'storage']) ||
      oldState.getIn(['userCampaign', 'data', 'data']);

    const newStorage = oldStorage.setIn(['currentPosition'], position);

    dispatch({
      type: SET_CALENDAR_CURRENT_POSITION,
      position,
      newStorage,
    });
    const fetch = buildFetch(dispatch);
    return fetch(`${config.api}/v2/campaigns/${campaignId}/storage`, {
      method: 'PATCH',
      data: {data: newStorage.toJS()},
    }).catch(err => {
      console.log(err);
      dispatch({
        type: 'GENERAL_ERROR',
        key: 'updateClendarStoreError',
        message: "Oops c'è stato un errore nel salvataggio dei dati",
      });

      dispatch({
        type: SET_CALENDAR_CURRENT_POSITION,
        position: oldState.getIn(['userCampaign', 'data', 'storage', 'currentPosition']),
      });
    });
  };
}

export const SET_NEW_CALENDAR_TESTS = 'SET_NEW_CALENDAR_TESTS';

export function setNewCalendarTests(tests) {
  return function (dispatch, getState) {
    const oldState = getState();
    const campaignId = oldState.getIn(['userCampaign', 'data', 'id']);
    const oldStorage =
      oldState.getIn(['userCampaign', 'data', 'storage']) ||
      oldState.getIn(['userCampaign', 'data', 'data']);

    const immutableTests = fromJS(tests);
    const newStorage = oldStorage.setIn(['tests'], immutableTests);

    dispatch({
      type: SET_NEW_CALENDAR_TESTS,
      tests: immutableTests,
    });
    const fetch = buildFetch(dispatch);
    return fetch(`${config.api}/v2/campaigns/${campaignId}/storage`, {
      method: 'PATCH',
      data: {data: newStorage.toJS()},
    }).catch(err => {
      console.log(err);
      dispatch({
        type: 'GENERAL_ERROR',
        key: 'updateClendarStoreError',
        message: "Oops c'è stato un errore nel salvataggio dei dati",
      });

      dispatch({
        type: SET_NEW_CALENDAR_TESTS,
        tests: oldStorage.get('tests'),
      });
    });
  };
}

export const SET_HAS_SEEN_CALENDAR_TUTORIAL = 'SET_HAS_SEEN_CALENDAR_TUTORIAL';

export function setHasSeenCalendarTutorial() {
  return function (dispatch, getState) {
    const oldState = getState();
    const campaignId = oldState.getIn(['userCampaign', 'data', 'id']);
    const oldStorage =
      oldState.getIn(['userCampaign', 'data', 'storage']) ||
      oldState.getIn(['userCampaign', 'data', 'data']);

    const newStorage = oldStorage.setIn(['hasSeenTutorial'], true);

    dispatch({
      type: SET_HAS_SEEN_CALENDAR_TUTORIAL,
      tests: oldStorage.get('tests'),
      currentPosition: oldStorage.get('currentPosition'),
    });
    const fetch = buildFetch(dispatch);
    return fetch(`${config.api}/v2/campaigns/${campaignId}/storage`, {
      method: 'PATCH',
      data: {data: newStorage.toJS()},
    }).catch(err => {
      console.log(err);
      dispatch({
        type: 'GENERAL_ERROR',
        key: 'updateClendarStoreError',
        message: "Oops c'è stato un errore nel salvataggio dei dati",
      });
    });
  };
}

// ===  For User Campaign List  ===
export const USERCAMPAIGNLIST_START_LOADING = 'USERCAMPAIGNLIST_START_LOADING';
export const USERCAMPAIGNLIST_LOADING_SUCCESS = 'USERCAMPAIGNLIST_LOADING_SUCCESS';
export const USERCAMPAIGNLIST_LOADING_ERROR = 'USERCAMPAIGNLIST_LOADING_ERROR';
export const USERCAMPAIGN_SELECT_SUCCESS = 'USERCAMPAIGN_SELECT_SUCCESS';
export const USERCAMPAIGN_SELECT_ERROR = 'USERCAMPAIGN_SELECT_ERROR';

export function startLoadingUserCampaignList() {
  return {
    type: USERCAMPAIGNLIST_START_LOADING,
  };
}

export function loadUserCampaignListSuccess(data = []) {
  return {
    type: USERCAMPAIGNLIST_LOADING_SUCCESS,
    data,
  };
}

export function selectUserCampaignSuccess(data = []) {
  return {
    type: USERCAMPAIGN_SELECT_SUCCESS,
    data,
  };
}

export const loadUserCampaignListError = createError(USERCAMPAIGNLIST_LOADING_ERROR);
export const selectUserCampaignError = createError(USERCAMPAIGN_SELECT_ERROR);

// == user campaign list from API==
export function loadUserCampaignList() {
  return function (dispatch, getState) {
    const fetch = buildFetch(dispatch);
    dispatch(startLoadingUserCampaignList());

    return fetch(`${config.api}/usercampaign/list`)
      .then(response => {
        const campaigns = response.data;
        const data = Immutable.fromJS(campaigns);
        dispatch(loadUserCampaignListSuccess(data));

        return data;
      })
      .catch(error => {
        dispatch({type: USERCAMPAIGNSLIST_LOADING_ERROR});

        if (!error) return;
        dispatch(loadUserCampaignListError(error.message));

        throw error;
      });
  };
}

export function setUserCampaignList(campaigns) {
  return function (dispatch) {
    const data = Immutable.fromJS(campaigns);

    dispatch(loadUserCampaignListSuccess(data));
  };
}

// == API call for selecting user campaign ==
export function selectUserCampaign(campaign_id, lang) {
  return function (dispatch) {
    const fetch = buildFetch(dispatch);

    return fetch(`${config.api}/usercampaign/${campaign_id}`, {method: 'POST', data: {lang}})
      .then(response => {
        return response.data;
      })
      .catch(error => {
        dispatch(selectUserCampaignError(error.message));
        throw error;
      });
  };
}
